import { moduleFactory } from "@/factories/module";
import { _normalizeFilename } from "./normalizeFilename";
import { _uploadFile } from "./uploadFile";

export const fileModule = moduleFactory.create({
  normalizeFilename: _normalizeFilename,
  uploadFile: _uploadFile,
});
